import Users from '@/views/Users'
import UsersNew from '@/views/UsersNew'
import UsersEdit from '@/views/UsersEdit'
import UsersSeatingStatus from '@/views/UsersSeatingStatus'

export default [
  {
    path: '/users',
    name: 'users',
    component: Users
  },

  {
    path: '/users/new',
    name: 'users-new',
    component: UsersNew
  },

  {
    path: '/users/:id/edit',
    name: 'users-edit',
    component: UsersEdit
  },

  {
    path: '/users/:id/seating-status',
    name: 'users-seating-status',
    component: UsersSeatingStatus
  }
]
